module.exports = __webpack_public_path__ + "static/media/google-plus.1e0e5f02.svg";